import { uploadEntityAttachments, deleteAttachment } from '@/lib/entity-attachments';

export interface LeadFileAttachment {
  id: string;
  file_name: string;
  file_type: string;
  file_size: number;
  file_url: string;
  created_at: string;
  created_by: string;
  created_by_user?: {
    display_name?: string | null;
  };
}

export async function uploadLeadAttachments(
  leadId: string | undefined,
  files: File[],
  companyId: string,
  userId: string
): Promise<LeadFileAttachment[]> {
  return uploadEntityAttachments('user', leadId, files, companyId, userId, { metadata: { document_type: 'lead_document' } });
}

export function deleteLeadAttachment(
  attachmentId: string,
  userId: string | undefined
): Promise<boolean> {
  return deleteAttachment(attachmentId, userId);
}

